import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const WhatsAppComponentTable4 = () => {
  const cellStyle = {
    border: "1px solid #D0D0D0",
    padding: "14px",
    fontSize: "15.5px",
    fontFamily: "'Roboto', sans-serif",
    verticalAlign: "top",
  };


  const rows = [
    {
      component: "Header (Text)",
      status: "Optional",
      description: "Short text at top",
      character_limit: "(≤ 60 chars, emojis OK)",
      supported: "✓",
    },
    {
      component: "Header (Media)",
      status: "Optional",
      description: "image/video/document at top (no caption allowed)",
      character_limit: "-",
      supported: "✓ (media only)",
    },
    {
      component: "Body Text",
      status: "Required",
      description: "Main prompt above buttons",
      character_limit: "(≤ 1,024 chars, emojis OK)",
      supported: "✓",
    },
    {
      component: "Footer Text",
      status: "Optional",
      description: "Helper text below the body",
      character_limit: "(≤ 60 chars, emojis OK)",
      supported: "✓",
    },
    {
      component: "Reply Buttons",
      status: "Required",
      description: "1–3 buttons; each with an ID and title",
      character_limit: "(≤ 20 chars, no emojis)",
      supported: "✗",
    },
    {
      component: "CTA URL Buttons",
      status: "Not supported",
      description: "Interactive messages allow only one type per payload.",
      character_limit: "-",
      supported: "✗",
    },
    {
      component: "List Messages",
      status: "Not supported",
      description: "Cannot co-exist with reply buttons in same message.",
      character_limit: "-",
      supported: "✗",
    },
    {
      component: "Additional Media Attachments",
      status: "Not supported",
      description: "Media attachments appear only in the header.",
      character_limit: "-",
      supported: "✗",
    },
  ];

  return (
    <TableContainer
      component={Paper}
      elevation={2}
      sx={{
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
        <TableHead sx={{ backgroundColor: "#f3f4f6" }}>
          <TableRow>
            {["Component", "Description", "Character Limit", "Supported?"].map((title) => (
              <TableCell sx={{ ...cellStyle, fontWeight: "bold", fontSize: "18px" }} key={title}>
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow
              key={idx}
              sx={{
                backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                transition: "background 0.3s",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              <TableCell sx={{ ...cellStyle, }}>{row.component}</TableCell>

              <TableCell sx={cellStyle}>
                <Typography
                  sx={{
                    fontSize: "15.5px",
                    fontStyle: "italic",
                    fontWeight: 600,
                    color:
                      row.status === "Required"
                        ? "green"
                        : row.status === "Optional"
                          ? "#D32F2F"
                          : "#000",
                    marginBottom: "4px",
                  }}
                >
                  {row.status}
                </Typography>

                <Typography sx={{ fontSize: "15.5px" }}>
                  {row.description}
                </Typography>
              </TableCell>

              <TableCell sx={{ ...cellStyle, textAlign: "center" }}>
                {row.character_limit}
              </TableCell>

              <TableCell sx={{ ...cellStyle, fontWeight: 600, textAlign: "center" }}>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "15.5px",
                    fontWeight: 600,
                    color: row.supported.includes("✓")
                      ? "green"
                      : row.supported.includes("✗")
                        ? "red"
                        : "inherit",
                    whiteSpace: "nowrap",
                  }}
                >
                  {row.supported}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WhatsAppComponentTable4;
